/* eslint-disable flowtype/require-return-type */
/* eslint-disable react/jsx-handler-names */
/* @flow strict */

import * as React from 'react';
import ReactDataSheet from 'react-datasheet';
import { emailRegexp, isNumberRegexp } from '/client/src/constants';

const initColumns = [
  { name: 'First Name' },
  { name: 'Last Name' },
  { name: 'Email' },
  { name: 'Phone' },
  { name: 'Number of tickets' },
  { name: 'Notes' }
];
const initEmptyRow = [
  {
    value: ''
  },
  {
    value: ''
  },
  {
    value: '',
    hint: 'valid',
    name: 'email'
  },
  {
    value: ''
  },
  {
    value: '',
    hint: 'valid',
    name: 'number'
  },
  {
    value: ''
  }
];

type PropsType = {
  setTableData: () => void,
  table: any,
  isSubmited: boolean,
  isLimit: boolean,
  ticketQuestions: any
};

// Do not rewrite into functional component. It might affect on react-datasheet
class AddGuestPageTable extends React.Component<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.state = {
       grid: [ initEmptyRow ],
       columns: initColumns,
       emptyRow: initEmptyRow,
       selected: null,
       isCloneButtonPressed: false
    };
  }

  componentDidMount() {
    document.addEventListener('mouseup', () => {
      this.setState({
        isCloneButtonPressed: false
      });
    });
  }

  componentDidUpdate(prevProps: any) {
    const { ticketQuestions } = this.props;

    if (this.props.isSubmited !== prevProps.isSubmited) {
      this.setState({
         grid: _.size(this.props.table) ? this.props.table : [ this.state.emptyRow ]
      });
    }
    if (ticketQuestions !== prevProps.ticketQuestions) {
      const emptyColumnsWithQuestions = _.size(ticketQuestions) ? [...initColumns, ...ticketQuestions.map((el: any): any => ({
        name: el.text
      }))] : initColumns;

      const emptyRowWithQuestions = _.size(ticketQuestions) ? [...initEmptyRow, ...ticketQuestions.map((el: any): any => ({
        value: '',
        id: el.id
      }))] : initEmptyRow;

      this.setState({
        columns: emptyColumnsWithQuestions,
        emptyRow: emptyRowWithQuestions,
        grid: [emptyRowWithQuestions]
      });
    }
  }

  cloneCells = (_selected: any) => {
    const clonedValue = this.state.grid[_selected.start.i][_selected.start.j].value;
    const minRow = Math.min(_selected.start.i, _selected.end.i);
    const maxRow = Math.max(_selected.start.i, _selected.end.i);
    const minCell = Math.min(_selected.start.j, _selected.end.j);
    const data = [];

    for (let i = minRow; i <= maxRow; i++) {
        data.push({
          cell: {
            value: ''
          },
          col: minCell,
          row: i,
          value: clonedValue
        });
    }

    this.handleCellsChanged(data);
  }

  handleSelected = (selected: {}) => {
    const { isCloneButtonPressed } = this.state;

    let _selected = selected;

    if (isCloneButtonPressed) {
      _selected = {
        start: { i: selected.start.i, j: selected.start.j },
        end: { i: selected.end.i, j: selected.start.j }
      };
      this.cloneCells(_selected);
    }

    this.setState({
      selected: _selected
    });
  }

  handleCellsChanged = (arrOfChanges: any, arrayOfAdditions: [] | null): void => {
    const { grid, columns, emptyRow } = this.state;

    let _grid = grid.map((row: any): any => [...row]);

    if (arrayOfAdditions) {
      const newRows = _.groupBy(arrayOfAdditions, 'row');

      _.map(newRows, (row: {}) => {
        const rowForGrid = [];

        _.map(row, (rowItem: {}, rowItemk: number) => {
          const obj = {};

          obj.value = rowItem.value;

          if (rowItemk === 2) {
            const isValid = _.size(rowItem.value) ? emailRegexp.test(rowItem.value) : true;

            obj.name = 'email';
            obj.hint = isValid ? 'valid' : 'not-valid';
          }

          if (rowItemk === 4) {
            const isValid = _.size(rowItem.value) ? isNumberRegexp.test(rowItem.value) : true;

            obj.name = 'number';
            obj.hint = isValid ? 'valid' : 'not-valid';
          }
          rowForGrid.push({ value: rowItem.value });
        });
        const remainRows = columns.length - rowForGrid.length;

        for (let i = 0; i < remainRows; i++) {
          rowForGrid.push({ value: '' });
        }

        if (_.some(rowForGrid, (rv: {}): boolean => _.size(rv.value))) {
          _grid.push(rowForGrid);
        }
      });
    }

    arrOfChanges.forEach(({ cell, row, col, value }: any) => {
      if (cell && cell.name === 'email') {
        const isValid = _.size(value) ? emailRegexp.test(value) : true;

        _grid[row][col] = { ..._grid[row][col], value, hint: isValid ? 'valid' : 'not-valid' };
      } else if (cell && cell.name === 'number') {
        const isValid = _.size(value) ? isNumberRegexp.test(value) : true;

        _grid[row][col] = { ..._grid[row][col], value, hint: isValid ? 'valid' : 'not-valid' };
      } else {
        _grid[row][col] = { ..._grid[row][col], value, hint: 'valid' };
      }
    });

    const lastRow = _grid[_.size(_grid) > 0 ? _.size(_grid) - 1 : 0];
    const lastRowHasAllData = _.some(lastRow, (item: []): boolean => _.size(item.value) > 0);

    if (lastRowHasAllData) {  // Insert new empty line
      _grid = [..._grid, emptyRow];
    }

    // providing question ids
    _grid = _grid.map((row: any) => row.map((cell: any, index: number) => { 
        if (index >= columns.length - this.props.ticketQuestions.length) {
          return {
            ...cell,
            id: this.props.ticketQuestions[index - (columns.length - this.props.ticketQuestions.length)].id
          };
        }
        return cell;
      }));

    this.setState({
      grid: _grid
    });

    this.props.setTableData(_grid);
  };

  renderSheet = (props: any) => {
    const { columns } = this.state;

    return (
      <table className={`${props.className} my-awesome-extra-class`}>
        <thead>
          <tr>
            <th className='cell read-only w50' readOnly />
            {columns.map((col: any, coli: number): React.Element<'th'> => (
              <th key={`coli-${coli}`} className='cell read-only' readOnly>{col.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.children}
        </tbody>
      </table>
    );
  };

  renderRow = (props: any) => {
    const { isLimit } = this.props;

    return (
      <tr style={{ background: isLimit ? '#f1b5b5' : '' }}>
        <td className='cell read-only'>
          {props.row + 1}
        </td>
        {props.children}
      </tr>
    );
  };

  renderCell = (props: any) => {
    const { row, col, children, selected, ...rest } = props;

    return (
      <td {...rest}
        style={{ background: props.cell.hint === 'not-valid' ? '#ffbcbc' : '' }}
      >
        {children}
        {this.renderCloneIcon(selected, row, col)}
      </td>
    );
  };

  renderCloneIcon = (isSelected: boolean, row: any, col: any) => {
    if (!isSelected) return;
    const { selected } = this.state;
    const startRow = selected?.start?.i;
    const startCol = selected?.start?.j;
    const endRow = selected?.end?.i;
    const endCol = selected?.end?.j;
    const _row = Math.max(startRow, endRow);
    const _col = Math.max(startCol, endCol);

    if (row === _row && col === _col) {
      return (
        <div className='clone-icon'
          onMouseDown={() => this.toggleCloneButtonPressed(true)}
        />
      );
    }
  };

  toggleCloneButtonPressed = (status: boolean) => {
    this.setState({
      isCloneButtonPressed: status
    });
  }

  render() {
  const { grid, selected, isCloneButtonPressed } = this.state;

  return (
    <ReactDataSheet
      data={grid}
      className={isCloneButtonPressed ? 'cloneMode' : ''}
      valueRenderer={(cell: any): any => cell.value}
      selected={selected}
      onSelect={this.handleSelected}
      onCellsChanged={this.handleCellsChanged}
      sheetRenderer={this.renderSheet}
      rowRenderer={this.renderRow}
      cellRenderer={this.renderCell}
    />
  );
}
}


export default AddGuestPageTable;
